import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { TradeAdminRoutingModule } from '../../../tradeAdmin-routing.module';
import { EnitComplainceRoutingModule } from '../../../eComplaince-routing.module'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../../../../../shared/shared.module'
import { CtclModule } from '../../../EnitTrade/ctcl/ctcl.module';

import { AgGridModule } from 'ag-grid-angular';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { HighchartsChartModule } from 'highcharts-angular';
import { MisReportComponent } from './mis-report/mis-report.component';
import { ReadonlyCancellationFormComponent } from './readonly-cancellation-form/readonly-cancellation-form.component';
import { ReadonlyFormComponent } from './readonly-form/readonly-form.component';
import { AnnualAuditModule } from '../../annual-compliance-audit/member/annual-audit-member.module';




@NgModule({
  declarations: [
    
    MisReportComponent,
    ReadonlyCancellationFormComponent,
    ReadonlyFormComponent


  ],
  imports: [
    
    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    AnnualAuditModule,
    HighchartsChartModule
  ]
})
export class AuthorisedPersonAdminModule { }
